const SUBSTITUTE_CONTACT = 'substituteContact';

export { SUBSTITUTE_CONTACT };
